<div class="on-boarding-container">
    <div class="header">
        <img src="https://supersee.io/wp-content/uploads/2025/02/Supersee_Logo-1.webp" alt="SuperSee Logo"
            style="max-width: 150px;">
        <div>
            <button type="button" (click)="openSupportChat()">
                <span class="material-symbols-outlined">chat_bubble</span> Need Help?
            </button>
            <button type="button" (click)="logoutUser()" class="logout">
                <span class="material-symbols-outlined">logout</span> Logout
            </button>
        </div>
    </div>

    <div class="section">
        <div class="form-section">
            <h2>Name your workspace</h2>
            <p>Optional. Used on your screens and this computer. You can change this later. No team member will be contacted.</p>
            <form [formGroup]="workspaceForm">
                <div class="form">
                    <div class="form-field">
                        <mat-form-field appearance="outline" class="custom-field" floatLabel="always">
                            <mat-label>Company name</mat-label>
                            <input matInput formControlName="company_name" title="Company Name"
                                placeholder="e.g. Acme PVT, LTD">
                        </mat-form-field>
                    </div>
                </div>
            </form>

            <div class="button-group">
                <button type="button" class="skip" (click)="skipWorkspace()" [disabled]="isShowLoading">
                    Skip for now
                </button>
                <button type="button" class="next" (click)="continueWorkspace()" [disabled]="isShowLoading">
                    <mat-spinner *ngIf="isShowLoading"></mat-spinner>
                    Continue
                </button>
            </div>
        </div>
    </div>
</div>
